import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../core/services/settings.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { SweetAlertService } from '../../../core/services/sweet-alert.service';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.scss']
})
export class Error404Component implements OnInit {

  constructor(public settings: SettingsService, public auth: OAuthService, private readonly sw: SweetAlertService,) { }

  public ngOnInit() {
  }
  public logOut(ev: Event) {
    ev.preventDefault();

    this.sw.confirm({ title: `Logout`, html: `Are you sure you want to logout?` })
      .then((confirm) => {
        if (confirm && confirm.value) {
          this.auth.logOut();
        }
      });
  }
}
